import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { FiProfileSizes, IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { SafeStyle } from '@angular/platform-browser';

@Component({
    selector: 'fi-profile-view-image',
    templateUrl: './profile-view-image.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./profile-view-image.component.scss'],
    host: { class: 'fi-profile-view-image' },
    standalone: false,
})
export class FiProfileViewImageComponent {
    FiProfileSizes = FiProfileSizes;
    @Input() profileImage: string | SafeStyle;
    @Input() profileLocked: boolean = false;
    @Input() profileIcon: string;
    @HostBinding('class.fi-profile-view-image-square')
    @Input()
    squareImage: boolean = false;
    @Input() profileData: IUserProfile;
}
